import {  FORMERROR_RESETFORMERRORSTATE, FORMERROR_SETFORMERRORSTATE , RESET_FORM_FIELDVALUES_STATE , SET_FROM_FIELDVALUE_STATE} from "../actions/actionFormError";
import { formerrorstate } from 'helpers';
import { formfields } from 'helpers';
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "formfields";

const initialState = {
    errorstate: formerrorstate.initialerrorstate,
    formfields :  loadState(sessionKey, formfields.initialfieldsstate) 
   
};

function formerrorreducer(state = initialState, action) {
    switch (action.type) {
        case FORMERROR_RESETFORMERRORSTATE: {
            return {
                ...state,
                errorstate: formerrorstate.initialerrorstate
            };
        }
        case FORMERROR_SETFORMERRORSTATE: {
            let newerrorstate = {...state.errorstate}
            newerrorstate[action.payload.errorfield] = {
                errorstate: action.payload.errorstate,
                errortext: action.payload.errortext
            }
            return {
                ...state,
                errorstate: newerrorstate
            }
        }
        case RESET_FORM_FIELDVALUES_STATE: {

            saveState(sessionKey,  formfields.initialfieldsstate)

            return {
                ...state,
                formfields: formfields.initialfieldsstate
            };
        }
        case SET_FROM_FIELDVALUE_STATE: {

            let newformfields = {...state.formfields}
            newformfields[action.payload.field] = {
                value: action.payload.value
            }

            saveState(sessionKey, newformfields)

            return {
                ...state,
                formfields: newformfields
            }
        }
        default: {
            return state;
        }
    }
}

export default formerrorreducer;
